import { template as template_bd85a9bf689b4db5a0b66fb02da0a447 } from "@ember/template-compiler";
import RouteTemplate from 'ember-route-template';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import EmberGrid from 'eflex/components/ember-grid';
import Spinner from 'eflex/components/spinner';
import AjaxTextIndicator from 'eflex/components/ajax-text-indicator';
import { getOwner } from '@ember/application';
import formatDate from 'eflex/helpers/format-date';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { isPresent } from '@ember/utils';
class FilesTemplate extends Component {
    get buildHistoryController() {
        return getOwner(this).lookup('controller:parts/build-history');
    }
    static{
        template_bd85a9bf689b4db5a0b66fb02da0a447(`
    <div class="file-data centered h-100 main-overflow">
      {{#if this.buildHistoryController.fetchBuildHistoryDetails.isRunning}}
        <Spinner />
      {{else}}
        <EmberGrid
          class="process-data-grid border"
          @data={{this.buildHistoryController.buildStatuses}}
          @fetch={{this.buildHistoryController.getNextBuildStatusesPage.perform}}
        >
          <thead>
            <tr>
              <th class="col-4">
                {{t "name"}}
              </th>
              <th class="col-4">
                {{t "filename"}}
              </th>
              <th>
                {{t "datetime"}}
              </th>
              <th class="col-1">
                {{t "download"}}
              </th>
            </tr>
          </thead>
          <tbody>
            {{#each this.buildHistoryController.buildStatuses as |buildStatus|}}
              {{#if (isPresent buildStatus.formattedUploadedFileData)}}
                <tr class="station-row">
                  <td class="station-row-label">
                    <div class="app-station-description">
                      {{buildStatus.stationName}}
                    </div>
                    <div class="spacer">
                      |
                    </div>
                    <div class="latest-timestamp">
                      {{formatDate buildStatus.timestamp}}
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                {{#each buildStatus.formattedUploadedFileData as |fileDatum|}}
                  <tr class="file-data-row">
                    <td class="task-name">
                      {{fileDatum.taskName}}
                    </td>
                    <td class="file-data-name">
                      {{fileDatum.fileName}}
                    </td>
                    <td class="file-data-timestamp">
                      {{formatDate fileDatum.timestamp}}
                    </td>
                    <td class="file-data-download col-1">
                      {{#if fileDatum.isExpired}}
                        <div class="text-gray"> {{t "fileExpired"}}</div>
                      {{else}}
                        <a href={{fileDatum.fileUrl}} target="_blank" rel="noopener noreferrer">
                          <FaIcon @icon="file" @prefix="fas" class="fa-file"/>
                        </a>
                      {{/if}}
                    </td>
                  </tr>
                {{/each}}
              {{/if}}
            {{/each}}
          </tbody>
          {{#if this.buildHistoryController.loadingTasks.isRunning}}
            <AjaxTextIndicator />
          {{/if}}
        </EmberGrid>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default RouteTemplate(FilesTemplate);
